// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonValidation = {
  required: "请填写${label}",
  stringMin: "${label}至少需要 ${min} 个字符",
  stringMax: "${label}不能超过 ${max} 个字符",
  numberRange: "${label}必须介于 ${min} 和 ${max} 之间",
  types: {
    email: "${label}不是合法的邮箱地址",
    number: "${label}不是合法的数字",
    url: "${label}不是合法的链接",
  },
} as const;
